export const theme = {
    primaryColor: '#26C281',
    secondaryColor: '#EB7A3F',
    linkColor: '#0056b3',
    titleFont: `'Montserrat', sans-serif`,
    normalFont: `'PT Serif', serif`,
    lowWeightFontColor: '#E6E0CB',
    highWEightFontColor: '#333333',
    globalBackgroundColor: '#fafafa'
};